import React, { useState, useEffect } from 'react';
import './InternCare.css';
import DynamicBanner from '../../include/DynamicBanner';
import api from '../../../../api';

// Import all the components
import Overview from './Partials/Overview';
import Team from './Partials/Team';
import Vision from './Partials/Vision';
import WhatWeDo from './Partials/WhatWeDo';
import Logo from './Partials/Logo';
import Collaboration from './Partials/Collaboration';
import Contact from './Partials/Contact';

const InternCare = () => {
    const [internCareData, setInternCareData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInternCareData = async () => {
            try {
                const response = await api.get("/api/sitepages/academic/intern-care");
                const data = response.data;

                if (data.status && data.data) {
                    // ✅ Format all image paths using API URL (except banner which is already correct)
                    const formattedData = formatImagePaths(data.data);
                    setInternCareData(formattedData);
                } else {
                    throw new Error("Invalid data structure");
                }
                
                setIsLoading(false);

            } catch (err) {
                console.error("Error fetching Intern Care data:", err);
                setError("Failed to load Intern Care data");
                setIsLoading(false);
            }
        };

        fetchInternCareData();
    }, []);

    // ✅ Function to format all image paths with API URL (except banner)
    const formatImagePaths = (data) => {
        const formattedData = { ...data };

        // Format team member images
        if (formattedData.team && Array.isArray(formattedData.team)) {
            formattedData.team = formattedData.team.map(teamGroup => ({
                ...teamGroup,
                members: teamGroup.members.map(member => ({
                    ...member,
                    image: member.image && !member.image.startsWith("http") 
                        ? `${process.env.REACT_APP_API_URL}/public${member.image}`
                        : member.image
                }))
            }));
        }

        // Format what_we_do images (including gallery for logos)
        if (formattedData.what_we_do?.main_image) {
            formattedData.what_we_do.main_image = 
                formattedData.what_we_do.main_image && !formattedData.what_we_do.main_image.startsWith("http") 
                    ? `${process.env.REACT_APP_API_URL}/public${formattedData.what_we_do.main_image}`
                    : formattedData.what_we_do.main_image;
        }

        if (formattedData.what_we_do?.gallery) {
            formattedData.what_we_do.gallery = formattedData.what_we_do.gallery.map(img =>
                img && !img.startsWith("http") ? `${process.env.REACT_APP_API_URL}/public${img}` : img
            );
        }

        // Format collaboration images
        if (formattedData.collaborations) {
            formattedData.collaborations = formattedData.collaborations.map(img =>
                img && !img.startsWith("http") ? `${process.env.REACT_APP_API_URL}/public${img}` : img
            );
        }

        // Format contact logos
        if (formattedData.contact?.items) {
            formattedData.contact.items = formattedData.contact.items.map(item => ({
                ...item,
                logo: item.logo && !item.logo.startsWith("http") 
                    ? `${process.env.REACT_APP_API_URL}/public${item.logo}`
                    : item.logo
            }));
        }

        return formattedData;
    };

    if (isLoading) {
    }

    if (error) {
        return (
            <div className="interncare-page">
                <div className="alert alert-danger text-center m-4" role="alert">
                    Error loading Intern Care data: {error}
                </div>
            </div>
        );
    }

    if (!internCareData) {
        return (
            <div className="interncare-page">
                <div className="alert alert-warning text-center m-4" role="alert">
                    No Intern Care data available at the moment.
                </div>
            </div>
        );
    }

    // ✅ Extract API Data
    const bannerData = internCareData.banner || {};
    const overviewData = internCareData.overview || {};
    const teamData = internCareData.team || [];
    const visionData = internCareData.vision || {};
    const whatWeDoData = internCareData.what_we_do || {};
    const collaborationData = internCareData.collaborations || [];
    const contactData = internCareData.contact || {};

    const bannerTitle = bannerData.title || "";
    const bannerImages = bannerData.images || [];
    const logoGallery = whatWeDoData.gallery || [];
        const mobileimage=bannerData.mobile_images ||[];

    return (
        <div className="interncare-page">
            {/* ✅ Dynamic Banner */}
            {bannerImages.length > 0 && (
                <DynamicBanner
                    title={bannerTitle}
                    bgImage={bannerImages}
                    bgImageMobile={mobileimage}
                />
            )}

            {/* ✅ Overview Section */}
            <Overview data={overviewData} />

            {/* ✅ Team Section */}
            <Team data={teamData} />

            {/* ✅ Vision Section */}
            <Vision data={visionData} />

            {/* ✅ What We Do Section */}
            <WhatWeDo data={whatWeDoData} />

            {/* ✅ Logo Section (Dynamic from what_we_do gallery) */}
            <Logo data={logoGallery} />

            {/* ✅ Collaboration Section */}
            <Collaboration data={collaborationData} />

            {/* ✅ Contact Section */}
            <Contact data={contactData} />
        </div>
    );
};

export default InternCare;